import { render, staticRenderFns } from "./protocol.vue?vue&type=template&id=2d892930&scoped=true&"
var script = {}
import style0 from "./protocol.vue?vue&type=style&index=0&id=2d892930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d892930",
  null
  
)

export default component.exports